export const NOTIFICATION_TYPES = {
    ACTION: 'ACTION',
    INFORMATION: 'INFORMATION',
    WARNING: 'WARNING',
    ALERT: 'ALERT',
};
